import {
  getGetTipiDomandaIdTraduzioniStatoQueryKey,
  getTraduzioni,
  postTraduzioni,
  postTraduzioniTranslate,
} from '@framework/api-client';
import { LanguageTag } from '@framework/i18n';
import { getNetworkErrorMessage } from '@framework/ui';
import { message } from 'antd';
import { useCallback, useState } from 'react';
import { useQueryClient } from 'react-query';

/**
 * Custom hook per le traduzioni con AI
 */
export function useTranslationWithAI(
  inquiryId: string,
  languageTag: LanguageTag,
) {
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const handleTranslateAI = useCallback(async () => {
    try {
      if (!languageTag) {
        message.error('Nessuna lingua selezionata');
        return;
      }
      setIsLoading(true);
      const translations = await getTraduzioni(
        { idTipoDomanda: inquiryId },
        {
          headers: { 'Accept-Language': languageTag },
        },
      );

      const aiTranslated = await postTraduzioniTranslate(
        {
          file: new Blob([translations], {
            type: 'text/csv',
          }),
        },
        {
          headers: {
            'Accept-Language': languageTag,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      const uploadResult = await postTraduzioni(
        {
          file: new Blob([aiTranslated], { type: 'text/csv' }),
        },
        { idTipoDomanda: inquiryId },
        {
          headers: {
            'Accept-Language': languageTag,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      message.success('Traduzione con AI completata con successo');

      await queryClient.invalidateQueries(
        getGetTipiDomandaIdTraduzioniStatoQueryKey(inquiryId),
      );

      setIsLoading(false);
      return uploadResult;
    } catch (e) {
      message.error(getNetworkErrorMessage(e, 'Si è verificato un errore durante la traduzione.')); // prettier-ignore
      console.error(`[useTranslationWithAI] Errore durante la traduzione`, {
        error: e,
      });
    } finally {
      setIsLoading(false);
    }
  }, [languageTag, inquiryId, setIsLoading]);

  return { handleTranslateAI, isLoading };
}
